import { Component, DoCheck } from 'angular-ts-decorators';
import { ApplicationAuthorization } from '../../services/application-authorization';
import { CurrentSession } from '@shared/app/scripts/services/current-session';

/**
 * swAllowedApp component wraps content to be shown if the users is allowed
 * to the current application. Similar, but more generic directive is {@link
 * swAllowed}
 *
 * # examples
 * <pre>
 * <sw-allowed-app>
 *   <sw-allowed-app-content>
 *     <!-- content that we want to show only only if the user is allowed to see
 *          the app -->
 *   </sw-allowed-app-content>
 * </sw-allowed-app>
 * </pre>
 */
@Component({
  selector: 'swAllowedApp',
  template: require('./sw-allowed-app.html').default,
  transclude: {
    content: '?swAllowedAppContent',
  },
})
export class SwAllowedAppComponent implements DoCheck {
  isUserAllowed: boolean;
  isSessionDefined: boolean;

  constructor(
    private applicationAuthorization: ApplicationAuthorization,
    private currentSession: CurrentSession,
  ) {
    'ngInject';

    this.isUserAllowed = false;
    this.isSessionDefined = false;
  }

  ngDoCheck() {
    this.isSessionDefined = this.currentSession.isLogged;
    this.isUserAllowed = this.applicationAuthorization.hasAccess();
  }
}
